import { get } from 'modules/api';
import { Urls } from 'modules/main';
import { Response } from 'modules/utils';

export const fetchAccessTokenRequest = (): Promise<
  Response<{ accessToken: string }>
> => {
  return get(Urls.TWILIO_ACCESS_TOKEN);
};
